import React from "react";
import { Link } from "react-router-dom";

interface OverviewCardProps {
  overview?: string;
  notables?: { link: string; photo: string | File | null }[];
}

const OverviewCard: React.FC<OverviewCardProps> = ({ overview, notables }) => {
  if (!overview && (!notables?.length)) {
    return null;
  }

  return (
    <div className="flex lg:flex-col lg:items-end lg:gap-[.625rem] self-stretch">
      {!!overview && (
        <>
          <span className="text-gray-font lg:text-lg lg:leading-8 self-stretch">
            {overview}
          </span>
          <hr className="flex h-0 lg:justify-center lg:items-center self-stretch"></hr>
        </>
      )}
      {notables && (
        <div className="flex lg:flex-col lg:items-start lg:gap-4 self-stretch">
          <span className="text-gray-font lg:text-[1.375rem] font-bold lg:leading-6 self-stretch">
            Notable
          </span>
          <div className="flex lg:items-start lg:gap-3 self-stretch">
            {notables.map((notable, index) => (
              <div
                key={index}
                className="flex lg:flex-col lg:gap-2 self-stretch"
              >
                <img
                  src={notable.photo as string}
                  alt="Notable"
                  className="flex w-20 h-20 lg:w-32 lg:h-32 self-stretch"
                ></img>
                <Link
                  className="text-gray-font lg:text-lg lg:leading-6 self-stretch"
                  to={notable.link}
                >
                  {notable.link}
                </Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OverviewCard;